<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large"
		 type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";


	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		AllowApplyForVerify
	} from '@/api/approval'
	import {
		getRelation,getUserInfo
	} from '@/api/employee'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				flowId:null,
				formLoading: false,
				listLoading: false,
				isDisabled: false,
        prevEmpNo: ""
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;

			this.getTemplate();
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法
			
			clickChoose: async function(dataVal, name) {
				var that=this;
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, async function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var title = that.logInfo.fullName;
						var user = res.result.userList[0];
						dataVal.Values=[];
						dataVal.Values.push([user.id, user.name]);
						dataVal.Value = user.name;
						if (title.indexOf("住宅行政支持组") > -1) {
							await that.getEmployeeRelation(user.id);
							that.templateData.TemplateContent.Controls.forEach((item) => {
								if (item.Property.Title[0].Text == "大区董事") {
									item.Values=that.findEmpByPositionName(that.relationList,"高级董事总经理",7);
									if (item.Values == null || item.Values.length <= 0) {
										//审批节点无人，跳过
										item.Values.push(that.$store.state.defaultMember);
									}
								}
								if (item.Property.Title[0].Text == "大区总经理") {
									item.Values=that.findEmpByPositionName(that.relationList,"总经理",8);
									if (item.Values == null || item.Values.length <= 0) {
										//审批节点无人，跳过
										item.Values.push(that.$store.state.defaultMember);
									}
								}
								if (item.Property.Title[0].Text == "逐级审批使用") {
									item.Values=that.getRelationList(that.relationList,6);
									if (item.Values == null || item.Values.length <= 0) {
										//审批节点无人，跳过
										item.Values.push(that.$store.state.defaultMember);
									}
								}
							});
						}
					}
				})
			},
			getTemplate:async function() {
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var empNo = this.logInfo.EmpNo
				var departs = this.logInfo.fullName.split("/");
				var jobLevel = this.logInfo.JobLevel;
				var that = this;
				if (departs.indexOf("房友圈") == -1 &&
					departs.indexOf("工商铺商业运营中心") == -1 &&
					departs.indexOf("代理") == -1 &&
					departs.indexOf("二级市场营运中心") == -1 &&
					departs.indexOf("住宅部") == -1 &&
					departs.indexOf("按揭金融服务中心") == -1 &&
					departs.indexOf("住宅行政支持组") == -1 &&
					departs.indexOf("风险管理部") == -1 &&
					departs.indexOf("藤云") == -1 &&
					this.isDisabled == false
				) {
					this.Message({
						message: '没有申请权限',
						type: 'error',
						duration: 1000
					});
					this.isDisabled = true;
				}
				await this.getEmployeeRelation(this.logInfo.EmpNo);
				await getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					controls.TemplateContent.Controls.forEach(async (item) => {
						if (item.Property.Title[0].Text == "部门 ") {
							if (departs.indexOf("华西区") > -1) {
								item.Value = departs[departs.indexOf("华西区") + 1] + "/" + that.logInfo.DeptName;
							} if (departs.indexOf("非营业部") > -1) {
								item.Value = departs[departs.indexOf("非营业部") + 1] + "/" + that.logInfo.DeptName;
							} if (departs.indexOf("营业部") > -1) {
								item.Value = departs[departs.indexOf("营业部") + 1] + "/" + that.logInfo.DeptName;
							} if (departs.indexOf("其他") > -1) {
								item.Value = departs[departs.indexOf("其他") + 1] + "/" + that.logInfo.DeptName;
							}
						}
						if (item.Property.Title[0].Text == "所在部门") {
							if (departs.indexOf("房友圈") > -1||departs.indexOf("藤云") > -1) {
								item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "房友圈"})[0].Key;
							}  
							else if (departs.indexOf("住宅行政支持组") > -1) {
								item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "住宅行政支持组"})[0].Key;
							}
							else if (departs.indexOf("住宅部") > -1) {
								item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "住宅部"})[0].Key;
							}  
							else if (departs.indexOf("按揭金融服务中心") > -1) {
								item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "汇瀚"})[0].Key;
							}
							else if (departs.indexOf("二级市场营运中心") > -1||departs.indexOf("代理")>-1) {
								item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "二级市场营运中心/代理"})[0].Key;
							}
							else if (departs.indexOf("工商铺商业运营中心") > -1) {
								item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "工商铺商业运营中心"})[0].Key;
							}
							else if (departs.indexOf("风险管理部") > -1){
								item.Value = item.Config.Selector.Options.filter(o => { return o.Value[0].Text == "风险管理部"})[0].Key;
							}
							if (empNo === "SC16003920"){
                item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "住宅部"})[0].Key;
              }
							item.Disable=true;
							item.IsShow=false;
						}
						if (item.Property.Title[0].Text == "请选择审批行政助理") {
							item.IsShow = false;
							if (departs.indexOf("住宅行政支持组") > -1) {
								item.IsShow = true;
								item.Property.Title[0].Text = "请选择营业部人员";
							} else {
								item.Values = [];
								item.Values.push(that.$store.state.defaultMember);
								item.Value = "默认总经理"
							}
						}
						if (item.Property.Title[0].Text == "申请类型其他内容") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "申请原因其他内容") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "大区董事") {
							item.IsShow = false;
							item.Values=[];
							item.Values=that.findEmpByPositionName(that.relationList,"高级董事总经理",7);
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(that.$store.state.defaultMember);
							}
						}
						if (item.Property.Title[0].Text == "大区总经理") {
							item.IsShow = false;
							item.Values=[];
							item.Values=that.findEmpByPositionName(that.relationList,"总经理",8);
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(that.$store.state.defaultMember);
							}
						}
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "逐级审批使用") {
							item.Values=[];
							item.IsShow = false;
							if (departs.indexOf("二级市场营运中心") > -1 || departs.indexOf("代理") > -1) {
								item.Values=that.getRelationList(that.relationList,8);
							}
							if (departs.indexOf("住宅部") > -1) {
								item.Values=that.getRelationList(that.relationList,6);
							}
							if (departs.indexOf("工商铺商业运营中心") > -1) {
								item.Values=that.getRelationList(that.relationList,6);
							}
							if (departs.indexOf("房友圈") > -1|| departs.indexOf("藤云") > -1) {
								item.Values=that.getRelationList(that.relationList,7);
							}
							if (departs.indexOf("按揭金融服务中心") > -1) {
								item.Values=that.getRelationList(that.relationList,7);
							}
							if (departs.indexOf("非营业部") > -1) {
								item.Values=that.getRelationList(that.relationList,8);
							}
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(that.$store.state.defaultMember);
							}
						}
					});
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					this.listLoading = false;
				});
				
			},
			getEmployeeRelation: async function(empNo) {
				await getRelation(empNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {
				if(name=="申请类型"){
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
					var option = null;
					controlInfo.Config.Selector.Options.forEach(item =>{
						if(item.Value[0].Text == "其他"){
							controlInfo.Values.forEach(e =>{
								if(e[0] == item.Key){
									option = item;
								}
							});
						}
					});
					var control = controls.filter(item => item.Property.Title[0].Text == "申请类型其他内容")[0];
					if (option != null) {
						control.IsShow = true;
						control.Property.Require = 1;
					} else {
						control.IsShow = false;
						control.Property.Require = 0;
					}
				}
				if(name=="申请原因"){
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Value[0].Text == "其他" && val.indexOf(item.Key) > -1;
						})[0];
					var control = controls.filter(item => item.Property.Title[0].Text == "申请原因其他内容")[0];
					if (option != null) {
						control.IsShow = true;
						control.Property.Require = 1;
					} else {
						control.IsShow = false;
						control.Property.Require = 0;
					}
				}
			},
			tableOperation(val, type, datas) {
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				// 申请类型：流水号+申请类型，如：【0001248】 放款（支付）
				// 申请原因：xxxxx
				// 申请时间：2019-01-10 10:0:00
			
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请类型"})[0]
				var control1Text=""
				control1.Values.forEach(e =>{
					control1.Config.Selector.Options.forEach(item =>{
						if(e[0] == item.Key){
							if(control1Text == ""){
								control1Text = item.Value[0].Text
							}else{
								control1Text += ","+item.Value[0].Text
							}
						}
					})
				})
				
				
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请类型： "+control1Text,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请原因"})[0]
				var control2Text=control2.Config.Selector.Options.filter(t=>{return t.Key==control2.Value})[0].Value[0].Text
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请原因："+control2Text,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请时间"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请时间："+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				this.templateData.SummaryList=SummaryList;
				
				isSubmit = true;
				this.listLoading = true;
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		},

	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
